import ShowDetailVideo from './ShowDetailVideo'

export default ShowDetailVideo
